import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronDown,
  faChevronUp,
  faClose,
} from '@fortawesome/pro-regular-svg-icons';

import { Accordion } from '@client/components/Accordion';
import { Button } from '@client/components/common/inputs/Button';
import { moveArray } from '@client/components/landing-page-builder/helpers';
import { FieldDesc } from '@client/pages/CustomProgramPage/common';
import { UseFormRegisterReturn } from 'react-hook-form';
import { TextField } from '@client/new/components/basic';
import { ReviewsSectionSchema } from '@client/pages/CustomProgramPage/OTPLandingPage.schema';

type Props = {
  value: ReviewsSectionSchema;
  onChange: (value: ReviewsSectionSchema) => void;
  register: (name: string) => UseFormRegisterReturn;
};
export const Reviews = ({ register: r, onChange, value }: Props) => {
  const reviews = value.reviews || [];

  function updateState(x: Partial<ReviewsSectionSchema>) {
    onChange({ ...value, ...x });
  }

  const remove = (i: number) => {
    updateState({
      reviews: [...reviews.slice(0, i), ...reviews.slice(i + 1)],
    });
  };

  const move = (from: number, to: number) => {
    updateState({ reviews: moveArray(reviews, from, to) });
  };

  const defaultPreviewText = 'Add your review here...';

  return (
    <div>
      <FieldDesc className="mb-0">
        - Review Body: maximum of 150 characters
      </FieldDesc>
      <FieldDesc>- Reviewer Name: maximum of 30 characters</FieldDesc>
      {reviews?.map((x, i) => {
        return (
          <div
            key={i}
            className="flex space-x-0 mb-4 items-start flex-col sm:flex-row sm:space-x-3"
          >
            <div className="w-[39px] h-[39px] shrink-0 rounded-lg text-lg flex items-center justify-center bg-[#E1E5F0] mb-3 sm:mb-0">
              {i + 1}
            </div>
            <Accordion
              hasError={false}
              title={x.text || defaultPreviewText}
              customizations={null}
              isPlaceholder={!x.text}
            >
              <div className="bg-white">
                <TextField
                  className="w-full min-h-100"
                  multiline
                  rows={2}
                  {...r(`reviews.${i}.text`)}
                  inputProps={{
                    maxLength: 150,
                    placeholder: defaultPreviewText,
                    className: `resize-none`,
                  }}
                />
              </div>
              <div className="max-w-[300px] w-fit mt-3">
                <TextField
                  {...r(`reviews.${i}.name`)}
                  size="small"
                  inputProps={{
                    placeholder: 'Name',
                    maxLength: 30,
                  }}
                />
              </div>
            </Accordion>

            <div className="flex items-center h-[39px] pl-[28px]">
              <div className="w-[40px]">
                {i > 0 && reviews.length > 1 ? (
                  <FontAwesomeIcon
                    icon={faChevronUp}
                    onClick={() => move(i, i - 1)}
                    className="-mb-0.5 cursor-pointer"
                  />
                ) : null}
              </div>
              <div className="w-[40px]">
                {i < reviews.length - 1 && reviews.length > 1 ? (
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    onClick={() => move(i, i + 1)}
                    className="cursor-pointer"
                  />
                ) : null}
              </div>
              <div className="w-[40px]">
                {reviews.length > 1 ? (
                  <FontAwesomeIcon
                    icon={faClose}
                    onClick={() => remove(i)}
                    className="cursor-pointer"
                  />
                ) : null}
              </div>
            </div>
          </div>
        );
      })}
      <Button
        onClick={() =>
          updateState({ reviews: [...reviews, { name: '', text: '' }] })
        }
      >
        Add Review
      </Button>
    </div>
  );
};
